import { Component, type PropsWithChildren, Suspense } from 'react';
import { LoaderCircle } from 'lucide-react';
import { Link, Outlet, useLocation } from 'react-router-dom';

class PageErrorBoundary extends Component<PropsWithChildren, { failed: boolean }> {
  state = { failed: false };

  static getDerivedStateFromError() {
    return { failed: true };
  }

  componentDidCatch() {
    // Keep arbitrary error text and URLs out of diagnostics: they may contain request data.
    console.error('Portal page failed to load or render.');
  }

  render() {
    if (this.state.failed) {
      return <main className="center-state" role="alert">
        <h1>Die Seite konnte nicht geladen werden.</h1>
        <p>Prüfe deine Verbindung und lade die Seite erneut.</p>
        <button className="button primary" onClick={() => window.location.reload()}>Seite neu laden</button>
        <Link className="button ghost" to="/">Zur Übersicht</Link>
      </main>;
    }
    return this.props.children;
  }
}

export function PageContent() {
  const { pathname } = useLocation();
  // A failed module must not prevent navigation to another page. Reload resets a rejected import.
  return <PageErrorBoundary key={pathname}>
    <Suspense fallback={<main className="center-state" role="status"><LoaderCircle className="spin" aria-hidden="true" /><p>Seite wird geladen …</p></main>}>
      <Outlet />
    </Suspense>
  </PageErrorBoundary>;
}
